/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'gslb-service-subheader';
const prefix = `${moduleName}.${componentName}`;

export const membersStatusLabel = `${prefix}.membersStatusLabel`;
export const fqdnInsightsLabel = `${prefix}.fqdnInsightsLabel`;
export const topologyLabel = `${prefix}.topologyLabel`;

export const ENGLISH = {
    [membersStatusLabel]: 'Members Status',
    [fqdnInsightsLabel]: 'FQDN Insights',
    [topologyLabel]: 'Topology',
};
